"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidNumber = isValidNumber;
exports.getValidNumber = getValidNumber;
exports.getSizeWindows = getSizeWindows;
exports.createIcon = createIcon;
exports.getAttributeHTML = getAttributeHTML;
exports.getRecordsPerPage = getRecordsPerPage;
exports.createEllipsis = createEllipsis;
exports.getShowRecordsPerPage = getShowRecordsPerPage;
exports.getShowInfoItems = getShowInfoItems;
exports.disableLink = disableLink;
exports.enableLink = enableLink;
exports.getRange = getRange;
var bc_paginator_v2_constants_1 = require("./bc-paginator-v2-constants");
function isValidNumber(text) {
    var value = Number.parseInt(text);
    return Number.isInteger(value) && value > 0;
}
function getValidNumber(dataNumber, defaultValue) {
    var validNumber = isValidNumber(dataNumber.toString());
    return validNumber ? dataNumber : defaultValue;
}
function getSizeWindows() {
    return {
        height: window.innerHeight,
        width: window.innerWidth,
    };
}
function createIcon(icon) {
    var bcIcon = document.createElement('i');
    bcIcon.classList.add('bc-icon', 'bc-sm');
    bcIcon.setAttribute('role', 'img');
    bcIcon.setAttribute('size', 'md');
    bcIcon.setAttribute('aria-hidden', 'true');
    bcIcon.textContent = icon;
    return bcIcon;
}
function getAttributeHTML(attributeName, defaultValue, element) {
    var attribute = element.getAttribute(attributeName);
    return attribute ? attribute : defaultValue;
}
function getRecordsPerPage(element) {
    var attributeValue = element.getAttribute('itemsPerPage');
    var validNumber = isValidNumber(attributeValue);
    return validNumber ? Number.parseInt(attributeValue) : bc_paginator_v2_constants_1.BcPaginatorV2Constants.BC_PAGINATOR_V2_RECORDS_PER_PAGE;
}
function createEllipsis() {
    var span = document.createElement('span');
    span.textContent = '...';
    return span;
}
function getShowRecordsPerPage(mySelf) {
    var attributeValue = mySelf.getAttribute('showPageSize') || '';
    return attributeValue.toLowerCase() === 'true';
}
function getShowInfoItems(mySelf) {
    var attributeValue = mySelf.getAttribute('showInfoItems') || '';
    return attributeValue.toLowerCase() === 'true';
}
function disableLink(linkElement) {
    linkElement.removeAttribute('href');
    linkElement.setAttribute('role', 'link');
    linkElement.setAttribute('aria-disabled', 'true');
}
function enableLink(linkElement, linkType) {
    linkElement.setAttribute('href', "#".concat(linkType));
    linkElement.removeAttribute('role');
    linkElement.removeAttribute('aria-disabled');
}
function getRange(start, end) {
    var length = end - start + 1;
    return Array.from({ length: length }, function (_, idx) { return idx + start; });
}
